import {
  ROMBELS_GET,
  ROMBEL_PORTALUSERS_GET,
  ROMBEL_UPDATE_PORTALUSER,
  ROMBEL_ADD,
  ROMBEL_EDIT,
  ROMBEL_GET,
  ROMBEL_DELETE,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
  gurus: [],
  jenjangs: [],
  kelass: [],
  years: [],
  sems: [],
  portalusers: [],
  classyears: [],
};

const rombelsGet = (state, payload) => {
  const rawRombels = payload.rombels;
  const total = rawRombels.total;
  const items = rawRombels.items;
  const search = rawRombels.search;
  const jenjangs = rawRombels.jenjangs;
  const kelass = rawRombels.kelass;
  const years = rawRombels.years;
  const sems = rawRombels.sems;
  return {
    ...state,
    total,
    items,
    search,
    jenjangs,
    kelass,
    years,
    sems,
  };
};

const rombelAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.rombel.id + ''),
      payload.rombel,
    ],
    search: { ...state.search },
  };
};

const rombelEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.rombel.id + ''),
      payload.rombel,
    ],
  };
};

const rombelGet = (state, payload) => {
  let rawRombel = payload.rombel;
  let rombel = rawRombel.rombel;
  let gurus = rawRombel.gurus;
  let jenjangs = rawRombel.jenjangs;
  let kelass = rawRombel.kelass;
  let years = rawRombel.years;
  let sems = rawRombel.sems;
  let newItems = [...state.items];

  if (rombel) {
    newItems = [
      ...state.items.filter((i) => i.id + '' !== rombel.id + ''),
      rombel,
    ];
  }
  let newState = {
    ...state,
    items: newItems,
    gurus,
    jenjangs,
    kelass,
    years,
    sems,
  };
  return newState;
};

const rombelPortalusersGet = (state, payload) => {
  let portalusers = payload.rombel.portalusers;
  let classyears = payload.rombel.classyears;
  return {
    ...state,
    portalusers,
    classyears,
  };
};

const rombelUpdatePortaluser = (state, payload) => {
  let portalusers = state.portalusers;
  let studentUserId = payload.studentUserId;
  let filteredPortalusers = portalusers.filter((i) => i.userId + '' !== studentUserId + '');
  return {
    ...state,
    portalusers: filteredPortalusers,
  };
};

const rombelDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [...state.items.filter((i) => i.id + '' !== payload.rombel.id + '')],
  };
};

export default createReducer(initialState, {
  [ROMBELS_GET]: rombelsGet,
  [ROMBEL_PORTALUSERS_GET]: rombelPortalusersGet,
  [ROMBEL_UPDATE_PORTALUSER]: rombelUpdatePortaluser,
  [ROMBEL_ADD]: rombelAdd,
  [ROMBEL_EDIT]: rombelEdit,
  [ROMBEL_GET]: rombelGet,
  [ROMBEL_DELETE]: rombelDelete,
});
